import React, { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, type BoxProps } from '@atlaskit/primitives/box';

export interface TRProps extends BoxProps<'tr'> {
	/**
	 * If the row has programatic selection applied.
	 */
	isSelected?: boolean;
}

/**
 * __Row__
 *
 * A row primitive.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */
export const TR: React.ForwardRefExoticComponent<
	Omit<TRProps, 'ref'> & React.RefAttributes<HTMLTableRowElement>
> = forwardRef<HTMLTableRowElement, TRProps>(({ isSelected, ...props }, ref) => {
	return <Box as="tr" tabIndex={-1} aria-selected={isSelected} ref={ref} {...props} />;
});
